<script>
	//import { onMount } from "svelte";
  import Scroller from "@sveltejs/svelte-scroller";

  import sectionsRaw from './content.yml';

  let sections = sectionsRaw;

  sections.forEach((s) => {
    if (!s.heading) {
      s.pars = [];
      s.text.split("\n").forEach((p) => {
        if (p.trim()) s.pars.push(p.trim());
      });

      s.guess = null;
      s.answered = false;
      s.correct = null;
    }
  });


  let nTotal;
  $: nTotal = sections.filter(s => !s.heading).length;
  let nAnswered;
  $: nAnswered = sections.filter(s => s.answered === true).length;
  let nCorrect;
  $: nCorrect = sections.filter(s => s.correct === true).length;


  let index = null;
  let progress = null;

  function guess(s, guess) {
    s.guess = guess;
    s.answered = true;
    s.correct = (s.guess === 'chatgpt' && !s.is_human) || (s.guess !== 'chatgpt' && s.is_human);

    sections = sections;
  }


  let showHeader = false;
  $: showHeader = (index !== null && index !== 0 && index !== sections.length + 1) && !(progress > 1);
  

</script>



<div class="chatgpt-scroller">

  <Scroller top={0} bottom={0} threshold={0.5} bind:index bind:progress query=".section">
    <div class="sections" slot="foreground">
      <div class="section trigger start"></div>
      {#each sections as section, i}

        {#if section.heading}
          <div class="section heading">
            {@html section.heading}
          </div>
        {:else}

          <div class="section" 
               class:active={index === i + 1}
               class:answered={section.answered}
               class:correct={section.correct === true}  
               class:wrong={section.correct === false} 
               class:guess-human={section.answered && section.guess !== "chatgpt"}
               class:guess-chatgpt={section.answered && section.guess === "chatgpt"}
          >
          <div class="section-title">Aussage {i } / {nTotal}</div>

            {#each section.pars as p}

              <div class="section-p">
                {p}
              </div>
            {/each}

            <!-- <div class="icon icon-correct"></div> -->

            <div class="buttons">
              <div class="button button-human" 
                    on:click={() => guess(section, section.answer)}>
                    <div class = "button-leftpart">
                      <div class ="button-portrait"
                            class:giffey={section.answer === "Giffey"}
                            class:wegner={section.answer === "Wegner"}
                            class:jarasch={section.answer === "Jarasch"}
                            class:portraip-pop-anim={(section.answered && section.guess !== "chatgpt" && section.correct === true) || (section.answered && section.guess === "chatgpt" && section.correct === false)}
                            class:giffey-gun={section.answer === "Giffey" && section.answered && section.guess !== "chatgpt" && section.correct === true }
                      
                      ></div>
                      <div style="display:inline-block">{section.answer}</div>
                    </div>
                    <div class = "button-rightpart">
                      <div class="icon-disabled"
                      class:icon-correct={section.answered && section.guess !== "chatgpt" && section.correct === true}
                      class:icon-wrong={section.answered && section.guess !== "chatgpt" && section.correct === false}
                      ></div>
                    </div>
                  
                  </div>

              <div class="button button-chatgpt" 
                    on:click={() => guess(section, "chatgpt")}>
                    <div class = "button-leftpart">
                      <div class ="button-portrait bot"
                      class:portraip-pop-anim={(section.answered && section.guess === "chatgpt" && section.correct === true) || (section.answered && section.guess !== "chatgpt" && section.correct === false)}
                      
                      ></div>
                      <div style="display:inline-block">ChatGPT</div>
                    </div>
                    <div class = "button-rightpart">
                      <div class="icon-disabled"
                      class:icon-correct={section.answered && section.guess === "chatgpt" && section.correct === true}
                      class:icon-wrong={section.answered && section.guess === "chatgpt" && section.correct === false}
                      
                      ></div>
                    </div>
                  
                  
                  </div>
                 
            </div>
            <div class="section-divider" ></div>

          </div>
        {/if}
      {/each}
      <div class="section trigger end"></div>
    </div>
	</Scroller>
</div>


<div class="chatgpt-header" class:hidden={!showHeader}>
  <div class="chatgpt-header-info">
    <div class="chatgpt-header-text">
      <span class="number-answered">{nAnswered} / {nTotal}</span> Fragen beantwortet.

      <span class="number-correct">{nCorrect} / {nAnswered}</span> Antworten korrekt.
    </div>

  </div>

  <div class="chatgpt-header-bar-container">
    <div class="chatgpt-header-bar" style="width:100%; background-color: #ECECEC; position:absolute; bottom: 0px; z-index: -1;"></div>
    <div class="chatgpt-header-bar" style:width="{nAnswered / nTotal * 100}%"></div>
  </div>
</div>
<style lang="scss">
  @import 'main.scss';

  .chatgpt-header {
    background: #fff;
    font-family: $ff-sans;
    font-size: 16px;
    line-height: 12px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 0px;
    transform: translateY(0);
    transition: transform 0.3s ease;
    box-shadow: 0px 5px 20px rgba(255, 255, 255, .5);

    &.hidden {
      transform: translateY(calc(-100% - 3px));
    }

    @media screen and (max-width: 410px) {
      line-height: 1.25;
      text-align: center;
    }
  }

  .chatgpt-header-info {
    display: flex;
    justify-content: center;
    padding:20px 0 20px 0;
  }

  .number-answered {
    background-color: #ECECEC;
    color: #6D6D6D;
    font-weight: 700;
    padding: 2px 5px 2px 5px;
    border-radius: 3px;
  }

  .number-correct {
    color: #15B607;
    background-color: #C6F8CB;
    font-weight: 700;
    padding: 2px 5px 2px 5px;
    border-radius: 3px;
  }



  .chatgpt-header-bar {
    height: 6px;
    background: #6D6D6D;
  }

  .chatgpt-scroller {
    z-index: 1;
    font-family: $ff-serif;
    max-width: 620px;
    width: calc(100% - 20px);
    margin: 50px auto;
  }

  .section {
    font-style: italic;
    margin: 0px 0 200px;
    font-size: 20px;
    line-height: 30px;
    position: relative;

    @media (max-width: 640px) {
      padding-left: 15px;
    }

    @media (max-width: 480px) {
      font-size: 17px;
      line-height: 224x;
    }

    &.heading {
      margin: 210px 0 20px 0px;
      font-size: 30px;
      line-height: 40px;
      font-style: normal;
      font-weight: bold;
      border-top: 1px solid transparent;
    }
  }

  .section-p {
    margin: 0px 0;
    font-size: 24px;
    line-height: 36px;
}

  

  .section.active:not(.heading) {
    &::before {
      content: ' ';
      position: absolute;
      left: -20px;
      width: 4px;
      top: 4px;
      bottom: 4px;
      background: #ccc;
      border-radius: 2px;

      @media (max-width: 640px) {
        left: 0;
        top: 6px;
        bottom: 6px;
      }
    }
  }


  .section-title {
    font-family: $ff-sans;
    font-size: 12px;
    font-style: normal;
    line-height: 19px;
    text-transform: uppercase;
    margin: 0px 0 0px 0px;
  letter-spacing: 1.4px;
  color: #999;
  opacity: 0;
  transition: opacity .3s ease;

}

 .active .section-title {
    opacity: 1 !important;
  }


  .section-divider {
    height: 1px; color:#ECECEC; background-color:#ECECEC; width: calc(100% - 7px); position: relative; top: 150px;
  }
  .buttons {
    margin-top: 25px;
    position: absolute;
    top: 100%;
    opacity: 0.8;
    transition: opacity 0.4s ease;
    display: flex;
    justify-content: center;
  }
  .button {
    font-family: $ff-serif;
    padding: 10px 12px;
   
    border-radius: 5px;
    border:1px solid transparent;
    background: #ECECEC;
    color: #2a2a2a;
    font-weight: 500;
    margin-right: 10px;
    font-size: 20px;
    line-height: 18px;
    white-space: nowrap;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    font-style: normal;
    cursor: pointer;
    transition: all .2s ease-out;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.17);
    min-width: 275px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 410px) {
       
       min-width: auto;
    }

    &:hover {
      box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.15)
    }


  }

  @media screen and (max-width: 620px) {

      .section {
        margin-bottom: 270px;
      }
      .section-title {top: 240px;}

     .buttons {
      display: block; 
      width: calc(100% - 55px);
    
    }
      .button {
        width: 100%;
        margin-top: 15px;
      
      }
      .section-divider {
        padding-left: 20px;
        top: 240px;
        width: calc(100% - 35px);
      }

      .section-p {
        font-size: 21px;
        line-height: 33px;
      }
    }





  .button-leftpart {
    display: flex;
    align-items: center;
  }





  .button.true-answer-true {
    color: #15B607;
    border: 1px solid #15B607;
    background-color: #C6F8CB;
  }

  .button.true-answer-false {
    color: #0B8A00;

  }
 
  .button.false {
    color:#B21F1F;
    border: 1px solid #B21F1F;
    background-color: #FF9E9E ;
  }


  .correct.guess-human .button-human,
  .correct.guess-chatgpt .button-chatgpt {
  color: #0B8A00;
    border: 1px solid #0B8A00;
    background-color: #C6F8CB;
} 

.wrong.guess-human .button-human,
.wrong.guess-chatgpt .button-chatgpt
{
  color:#B21F1F;
    border: 1px solid #B21F1F;
    background-color: #FF9E9E ;
} 

.wrong.guess-human .button-chatgpt,
.wrong.guess-chatgpt .button-human
{
  color: #0B8A00;
  background-color: #D7FADB;

} 


  .active .buttons {
    opacity: 1;
  }

  .answered .buttons {
    pointer-events: none;
  }

  .guess-human .button-chatgpt,
  .guess-chatgpt .button-human  {
    opacity: 0.7;
  }



/*  

    .wrong {
    color: #B21F1F;
  }


  .correct {
    color: #0B8A00;
  }
*/

  .icon-disabled {
    display: inline-block;
    height: 15px;
    width: 29px;
    background: rgba(255,255,255,0);
    background-size: contain;
    background-repeat: no-repeat;
  }

  .icon-correct {
    background-image: url(../assets/icon_correct.svg);
  }

  .icon-wrong {
    background-image: url(../assets/icon_wrong.svg);
  }

  .button-portrait {
    width: 48px;
    height: 48px;
    margin-right: 10px;
    display: inline-block;
    border: 2px solid #fff;
    border-radius: 50%;
    background-size: contain;
    background-image: url(../assets/bot-portrait.png);
    
  }

    .giffey {
      background-image: url(../assets/giffey.webp);
      background-size: contain;
    }

    .giffey-gun {
      background-image: url(../assets/giffey-gun.png);
      background-size: contain;
    }

    .wegner {
      background-image: url(../assets/wegner.webp);
      background-size: contain;
    }
    .jarasch {
      background-image: url(../assets/jarasch.webp);
      background-size: contain;
    }
    .bot {
      background-image: url(../assets/bot-portrait.png);
      background-size: contain;
      border:none;
      border-radius: 0px;
    }

    @keyframes portraitPop {
      0% {
        transform: scale(1);
      }
      16% {
        transform: scale(1.17);
      }
      45% {
        transform: scale(1);
      }
      60% {
        transform: scale(1.12);
      }
      100% {
        transform: scale(1);
    }
  }
  @keyframes portraitPopGiffey {
      0% {
        transform: scale(1);
        filter: brightness(1);
      }

      8% {
        filter: brightness(2);
      }

      16% {
        transform: scale(1.17);
        filter: brightness(1);
      }

      30% {
        filter: brightness(2);
      }

      45% {
        transform: scale(1);
        filter: brightness(1);
      }

      60% {
        transform: scale(1.12);
        filter: brightness(2);
      }
      80% {
        filter: brightness(1);
      }

      100% {
        transform: scale(1);
        filter: brightness(1);
    }
  }

.portraip-pop-anim {
  animation: .8s 1 normal portraitPop;
}
 
.portraip-pop-anim.giffey-gun{
  animation: .8s 1 normal portraitPopGiffey;
}





  .section.trigger {
    height: 10px;
  }

  .pic {
    pointer-events: none;
    position: absolute;
    left: calc(50% - 50px);
    top: calc(50% - 50px);
    background-size: contain;
    width: 100px;
    height: 100px;
    opacity: 0;
    transform-origin: center center;
    transform: scale(0);
    transition: transform 0.6s cubic-bezier(0.36, 0, 0.66, -0.56), opacity 0.3s ease;

    &.pic-correct {
      background-image: url(../assets/hand.jpg);
    }

  }

  .correct .icon-correct {
    transform: scale(1);
    opacity: 1;
  }
</style>
